var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",style:({
    'background-image':
      'url(' + require('@/assets/images/footer-bg.png') + ')',
  })},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"text-center mt-5"},[_c('p',{staticClass:"text-white-50 f-15 mb-0"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" © DPMPTSP Kabupaten Sintang ")])])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }